module.exports = __webpack_public_path__ + "img/31.43a531de.jpg";